import { injectable, inject } from 'inversify';
import { UploadDispatcher } from '@dealroadshow/file-uploader';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import BulkQuestionUploadAdapter
  from '@/dataroom/infrastructure/api/FileUploadDispatcher/uploadAdapters/BulkQuestionUploadAdapter';
import BulkQuestionUploadStrategy
  from '@/dataroom/infrastructure/api/FileUploadDispatcher/uploadAdapters/uploadStrategy/BulkQuestionUploadStrategy';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DataroomTenantContextSymbol, type IDataroomTenantContext } from '@dataroom/tenant/types';
import Container from '@framework/di/Container';

@injectable()
class BulkQuestionUploadDispatcherFactory {
  constructor(
    @inject(Container) private readonly container: Container,
  ) {}

  create = (tenantCode: DataroomTenant | null = null) => {
    const tenant = tenantCode || this.container.get<IDataroomTenantContext>(DataroomTenantContextSymbol).tenant;

    validateDataroomTenant(tenant);

    const bulkQuestionUploadAdapter = new BulkQuestionUploadAdapter({ url: dataroomUrl(tenant).getQnABulkUploadUrl() });

    return new UploadDispatcher(new BulkQuestionUploadStrategy(bulkQuestionUploadAdapter));
  };
}

export default BulkQuestionUploadDispatcherFactory;
